import { createEventDefs } from "../event-def";

export const SessionEvents = createEventDefs<{
  login_callback_status: {
    status: "success" | "fail";
    state?: string;
    error_message?: string;
  };
  generate_auth_url_status: {
    status: "success" | "fail";
    state?: string;
    error_message?: string;
  };
  start: {
    initial_load_latency_ms: number;
  };
  page_view: {
    route: string;
  };
  intercom_opened: void;
  intercom_load_failed: {
    error_message: string;
  };
  logout: {
    reason: "logout_clicked" | "refresh_access_token_failure" | "account_deleted";
    error?: unknown;
  };
}>({ namespacePrefix: "studio_session_" });
